import React from "react";

import "@ant-design/compatible/assets/index.css";
import { Button, Select, Form, AutoComplete, Input, Popconfirm } from "antd";

const { Option } = Select;

class FormOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainRole: null,
      roleName1: null,
    };
  }

  mainRoleOnChange = (v) => {
    const { formRef, mainRoleOnChange, selectData } = this.props;

    if (selectData) {
      formRef.current.setFieldsValue({ role_name_1: "", role_name: null });
      mainRoleOnChange(v);
    } else {
      formRef.current.setFieldsValue({ role_name: null });
      mainRoleOnChange(v);
    }
    // formRef.current.setFieldsValue({  role_name: null });

    this.setState({ mainRole: v });
  };

  roleIdOnChange = (e) => {
    this.props.roleIdOnChange(e);
  };
  formOneOnFinish = (e) => {
    this.props.formOneOnFinish(e);
  };
  formOneOnFinishFailed = (e) => {
    console.log(e, "formOneOnFinishFailed");
  };
  roleDelete = (e) => {
    this.props.roleDelete(e);
  };

  render() {
    const {
      mainRolesGetData,
      rolesListGetData,
      roleName1OnChange,
      selectData,
      formRef,
      roleDeletePermission,
    } = this.props;

    const formOneValues = formRef?.current?.getFieldValue() ?? null;

    const mainRolesOptions = mainRolesGetData.sort((a, b) => a.main_role_name.localeCompare(b.main_role_name)).map((d) => (
      <Option key={d._id}>{d.main_role_name}</Option>
    ));
    // const rolesOptions = rolesListGetData.map((d) => (
    //   <Option key={d._id}>{d.role_name}</Option>
    // ));

    const rolesOptions = rolesListGetData
      .filter((item) => {
        if (formOneValues && formOneValues.main_role) {
          if (item.main_role_id === formOneValues.main_role) {
            return true;
          }
          return false;
        }
        return true;
      })
      .map((d) => {
        return { value: d.role_name };
        // <Option key={d._id} value={d.role_name}>
        //   {d.role_name}
        // </Option>
      });

    const rolesListDataSource = rolesListGetData.map((d) => {
      return { value: d.role_name };
    });

    return (
      <Form
        labelCol={{
          xs: { span: 24 },
          sm: { span: 6 },
          md: { span: 6 },
          lg: { span: 6 },
          xl: { span: 6 },
          xxl: { span: 6 },
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 18 },
          md: { span: 18 },
          lg: { span: 15 },
          xl: { span: 15 },
          xxl: { span: 15 },
        }}
        ref={formRef}
        onFinish={this.formOneOnFinish}
        onFinishFailed={this.formOneOnFinishFailed}
        // initialValues={formFourInitialValues}
        scrollToFirstError={true}
      >
        <Form.Item
          name="main_role"
          label="Main Role"
          rules={[
            {
              required: true,
              message: "Please Enter Main Role",
            },
          ]}
        >
          <Select
            showSearch
            allowClear={true}
            optionFilterProp="children"
            notFoundContent={null}
            placeholder="Enter Main Role"
            onChange={this.mainRoleOnChange}
            // disabled={selectData? true : false}
          >
            {mainRolesOptions}
          </Select>
        </Form.Item>
        <Form.Item
          name="role_name_1"
          label="Role"
          rules={[
            { whitespace: true, message: "Please Enter Role" },
            {
              required: true,
              message: "Please Enter Role",
            },
          ]}
        >
          {/* <Select
            showSearch
            // allowClear={true}
            optionFilterProp="children"
            notFoundContent={null}
            placeholder="Enter Hotel Management Group"
            onChange={roleName1OnChange}
          >
            {rolesOptions}
          </Select> */}

          <AutoComplete
            options={rolesOptions}
            placeholder="Enter Role Name"
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            onChange={roleName1OnChange}
            allowClear={true}
          />
        </Form.Item>
        {selectData ? (
          <Form.Item
            name="role_name"
            label="Rename Role Name"
            rules={[
              { whitespace: true, message: "Please Enter Rename Role Name" },
              { required: true, message: "Please Enter Rename Role Name" },
            ]}
          >
            <Input />
          </Form.Item>
        ) : null}

        <Form.Item wrapperCol={{ sm: {span: 12, offset: 6} }}>
          <Button type="primary" htmlType="submit">
            {selectData ? "Update " : "Create"}
          </Button>
          {roleDeletePermission && selectData && selectData._id ? (
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => this.roleDelete(selectData._id)}
            >
              <Button type="default" danger style={{ marginLeft: "10px" }}>
                Delete
              </Button>
            </Popconfirm>
          ) : null}
        </Form.Item>
      </Form>
    );
  }
}

// const WrappedApp = Form.create({ name: "form_one" })(FormOne);

export default FormOne;
